import React from 'react';

import { Text } from '@infinex/ui/components';

interface SolanaActionsProps {
  actions: string;
}

export function SolanaActions({ actions }: SolanaActionsProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <Text className="text-default shrink-0 text-sm font-medium">Actions</Text>
      <Text className="text-emphasis max-w-[60%] text-right text-sm font-medium wrap-break-word">
        {actions}
      </Text>
    </div>
  );
}
